import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import styles from './GiftCardFAQ.module.css';

/**
 * GiftCardFAQ Component
 * FAQ accordion section for gift card system
 */
const GiftCardFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqItems = [
    {
      question: 'How to get gift cards?',
      answer: 'Gift cards are provided through promotional campaigns, special events, or as rewards. You can receive gift card codes via email, SMS, or through our promotional channels. Each gift card comes with a unique activation code.',
    },
    {
      question: 'What are available and active gift cards?',
      answer: 'Available gift cards are those you have received but haven\'t activated yet. Active gift cards are those you have activated and are currently working towards completing the requirements (such as wager requirements) before you can claim them.',
    },
    {
      question: 'Do I need to wager gift cards?',
      answer: 'Some gift cards may have wager requirements. The wager requirement is calculated as: Gift Card Amount × Wager Multiplier. For example, a ₹500 gift card with a 5x wager requirement means you need to wager ₹2,500 before you can claim it. Not all gift cards have wager requirements.',
    },
    {
      question: 'How do I use gift card funds?',
      answer: 'Once you claim a gift card, the amount is added to your wallet balance. You can use these funds to place bets, play games, or make deposits. However, gift card funds cannot be withdrawn until any wager requirements are completed.',
    },
    {
      question: 'In which games can I wager gift cards?',
      answer: 'You can wager gift card funds in most games available on our platform, including casino games, sports betting, and other gaming options. The wager progress is tracked across all eligible games.',
    },
    {
      question: 'In which cases can gift card funds be cancelled and removed?',
      answer: 'Gift card funds may be cancelled or removed if: (1) The gift card expires before you complete the requirements, (2) You violate our terms and conditions, (3) The gift card was obtained fraudulently, or (4) The promotional campaign terms are not met. Always check the expiry date and terms of your gift card.',
    },
  ];

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className={styles.faqContainer}>
      <h2 className={styles.faqTitle}>FAQ</h2>
      <div className={styles.faqGrid}>
        {faqItems.map((item, index) => (
          <div key={index} className={styles.faqItem}>
            <button
              className={`${styles.faqQuestion} ${openIndex === index ? styles.faqQuestionOpen : ''}`}
              onClick={() => toggleItem(index)}
              aria-expanded={openIndex === index}
            >
              <span className={styles.faqQuestionText}>{item.question}</span>
              <ChevronDown 
                className={`${styles.faqChevron} ${openIndex === index ? styles.faqChevronOpen : ''}`}
                size={20}
              />
            </button>
            {openIndex === index && (
              <div className={styles.faqAnswer}>
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default GiftCardFAQ;
